var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen || _vm.persistent
    ? _c(
        "div",
        {
          staticClass:
            "comment__new comment__reply comment__reply-grey rounded",
          class: _vm.isOpen ? "" : "collapsed"
        },
        [
          _c("span", {
            staticClass: "comment__item__author__picture",
            style: _vm.makeProfileStyle(_vm.user)
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpen,
                  expression: "isOpen"
                }
              ],
              staticClass: "comment__new__wrapper"
            },
            [
              _c("button", {
                staticClass: "vs-btn-legacy btn-close md-close",
                attrs: { type: "button" },
                on: { click: _vm.close }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "comment__new__content" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.body,
                      expression: "body"
                    }
                  ],
                  ref: "textarea",
                  staticClass: "comment__new__textarea",
                  attrs: {
                    placeholder: _vm.$t(
                      "video.action.conversations.write_response"
                    )
                  },
                  domProps: { value: _vm.body },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.body = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "comment__new__send vs-btn btn btn--black--a05 rounded ladda-button",
                  attrs: { type: "submit", disabled: _vm.isPosting },
                  on: { click: _vm.postReply }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("video.action.conversations.send")) +
                      "\n      "
                  ),
                  _c("i", {
                    staticClass: "status",
                    class: _vm.isPosting ? "loading" : ""
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isOpen,
                  expression: "!isOpen"
                }
              ],
              staticClass: "comment__new__wrapper"
            },
            [
              _c("div", { staticClass: "comment__new__content" }, [
                _c(
                  "button",
                  {
                    staticClass: "vs-btn btn comment__new__btn",
                    on: { click: _vm.open }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "video.action.conversations." +
                              (_vm.user ? "write_response" : "new_submit")
                          )
                        ) +
                        "\n      "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }